// extracted by mini-css-extract-plugin
export var labelWrapper = "_d3-0";